/**
 * @file Album folder related fragments for Web Galleries.
 */

import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../../../../graphql/fragments/album';
import { WebGalleryAlbumListingDetails } from './album';

export const WebGalleryAlbumFolderHeroImage = gql`
  fragment WebGalleryAlbumFolderHeroImage on AlbumFolder {
    id
    hero_image {
      id
      url
    }
  }
`;

export const WebGalleryAlbumFolderFieldDetails = gql`
  fragment WebGalleryAlbumFolderFieldDetails on AlbumFolder {
    is_web_gallery
    is_private_web_gallery
    download_without_watermark
    download_without_purchase
    print_without_watermark
    social_share_enabled
    hash_code
    web_gallery_print_purchases_enabled
    web_gallery_price_per_photo {
      value
    }
  }
`;

export const WebGalleryAlbumFolderAccessFields = gql`
  fragment WebGalleryAlbumFolderAccessFields on AlbumFolder {
    id
    has_password
    invite_only_access
    contributor_access {
      upload_access
      view_access
    }
    root {
      id
      has_password
      invite_only_access
    }
  }
`;

export const WebGalleryAlbumFolderDetails = gql`
  fragment WebGalleryAlbumFolderDetails on AlbumFolder {
    id
    name
    join_code
    album_type
    album_subtype
    is_demo
    album_identity_access
    individual_albums
    start_date
    end_date
    joins_enabled
    all_photos_mode
    has_album_photos
    join_type
    joins_enabled
    privacy
    web_app_urls {
      onboarding_url
    }
    hero_image {
      id
      url
    }
    cover_photos(slice: { limit: 1 }) {
      records {
        id
        thumbnail_urls(ignore_watermark: true) {
          ...PhotoUrlTypeFields
        }
      }
    }
    price {
      currency
      value
    }
    parent {
      id
      name
    }
    root {
      id
      ...WebGalleryAlbumFolderHeroImage
    }
    ...WebGalleryAlbumFolderHeroImage
    ...WebGalleryAlbumFolderFieldDetails
    ...WebGalleryAlbumFolderAccessFields
  }
  ${PhotoUrlTypeFields}
  ${WebGalleryAlbumFolderFieldDetails}
  ${WebGalleryAlbumFolderHeroImage}
  ${WebGalleryAlbumFolderAccessFields}
`;

export const WebGalleryAlbumFolderChildrenCounts = gql`
  fragment WebGalleryAlbumFolderChildrenCounts on AlbumFolder {
    id
    children {
      album_folders {
        total
      }
      albums {
        total
      }
    }
  }
`;

export const WebGalleryAlbumFolderChildrenDetails = gql`
  fragment WebGalleryAlbumFolderChildrenDetails on AlbumFolder {
    id
    children {
      album_folders {
        total
        records {
          ...WebGalleryAlbumFolderDetails
          ...WebGalleryAlbumFolderChildrenCounts
        }
      }
      albums {
        total
        records {
          ...WebGalleryAlbumListingDetails
        }
      }
    }
  }
  ${WebGalleryAlbumFolderDetails}
  ${WebGalleryAlbumFolderChildrenCounts}
  ${WebGalleryAlbumListingDetails}
`;
